import {
  IconCheck,
  Label,
  Skeleton,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { memo } from 'react';
import { ICON_SIZE } from '../constants';
import styles from '../TransactionDetailSection.module.scss';
import { TransactionFieldItemProps } from '../types';

const cx = classnames.bind(styles);

export const TransactionFieldItem = memo(
  ({
    title,
    titleTooltip,
    titleTooltipIcon,
    content,
    contentTooltip,
    contentTooltipIcon,
    isSelected = false,
    isLoadingPulldownOptions,
    componentType,
  }: TransactionFieldItemProps) => {
    const contentContainerClassName = isSelected
      ? cx('listViewItemContentContainer', 'selected')
      : cx('listViewItemContentContainer');

    return (
      <div className={cx('listViewItemContainer')}>
        <div className={cx('left')}>
          <Label
            labelClassName={cx('listViewItemContent')}
            labelContentClassName={cx('listViewItemTitle')}
            text={title}
            tooltip={titleTooltip}
            tooltipIcon={titleTooltipIcon}
          />
        </div>
        <div className={contentContainerClassName}>
          <div className={cx('headerIcon')}>
            {isSelected && <IconCheck height={0} size={ICON_SIZE} width={0} />}
          </div>
          {componentType === 'pulldown' && isLoadingPulldownOptions ? (
            <Skeleton.Input active size='small' block />
          ) : (
            <Label
              labelClassName={cx('listViewItemContent')}
              text={content}
              tooltip={contentTooltip}
              tooltipIcon={contentTooltipIcon}
            />
          )}
        </div>
      </div>
    );
  }
);

TransactionFieldItem.displayName = 'TransactionFieldItem';
